import { forwardRef } from 'react'
import { GitbookLinks } from '../../utils/constants'

const ImageGuideLayer = forwardRef((props, ref) => (
  <div
    ref={ref}
    className="tooltip_basic ly_guide"
    style={{
      position: 'fixed',
    }}>
    <strong className="screen_out">심사 가이드</strong>
    <ul className="reform_list_guide">
      <li>
        <a
          href={GitbookLinks.PREMIUM_LINK_REGISTRATION}
          className="reform_link_guide"
          target="_blank"
          rel="noopener noreferrer">
          프리미엄링크 심사 가이드
          <span className="ico_comm ico_outlink" />
        </a>
      </li>
      <li>
        <a
          href={GitbookLinks.TALK_CHANNEL_REGISTRATION}
          className="reform_link_guide"
          target="_blank"
          rel="noopener noreferrer">
          톡채널검색 심사 가이드
          <span className="ico_comm ico_outlink" />
        </a>
      </li>
    </ul>
  </div>
))
ImageGuideLayer.displayName = 'ImageGuideLayer'
export default ImageGuideLayer
